import React from "react";
//import CustomLink from "@/bit/components/components.custom-link";
import CustomLink from "@/bit/components/components.custom-link";
import Text from "@/bit/components/components.text";

const Header0Skip = () => {
  const clickHandler = () => {
    const element = document.querySelector("main");
    if (element) {
      var firstFocusableElement = element.querySelector(
        "input, select, textarea, button, object, a, area[href], [tabindex]"
      );
      firstFocusableElement?.focus();
    }
  };

  return (    
      <div className="header0-skip">
        <CustomLink          
          onClick={clickHandler}
          title="Saltar al contenido principal"
          taggingInfo={{}}
        >
          <Text
            text="Saltar al contenido principal"
            align="center"
            color="blue_a_1"
            decoration="underline"
          />
        </CustomLink>         
      <style jsx>{`@import "styles/colors.scss";

.header0-skip :global(button) {
  position: absolute;
  z-index: -2;
  width: 1px;
  height: 1px;
  overflow: hidden;
  top: auto;
  left: -999px;
  background-color: white;
}
.header0-skip :global(button:focus) {
  width: 100%;
  height: 80px;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  padding: 2rem;
  border: 1px dashed $color--blue_800;
  outline:none;
}`}</style>
    </div>
  );
};

export default Header0Skip;
